/* ============================================================
   sb-consent-embed.js — Klick-zum-Laden fuer Drittanbieter-Embeds
   ============================================================
   Gehoert zu snippets/sb-consent-embed.liquid. Das Snippet rendert
   nur eine Platzhalterkarte; das <iframe> entsteht erst hier, und
   erst wenn eine der beiden Bedingungen erfuellt ist:

     1. Der Besucher klickt den Knopf. Der Klick IST die
        Einwilligung fuer genau diesen Abruf.
     2. Es liegt eine Komfort-Einwilligung vor (p === 1), die NICHT
        aelter ist als der Banner-Text, der den Dienst benennt
        (data-since, gesetzt vom Snippet).

   Die zweite Bedingung traegt eine Rechtsgrundlage, keine Bequem-
   lichkeit: die Karte darf bei p === 1 nur deshalb ohne Klick
   laden, weil der Banner Google Maps unter Komfort auffuehrt.
   Faellt diese Zeile aus dem Banner, laedt die Karte auf Basis
   eines Textes, den niemand gelesen hat. tools/sb-consent-test.js
   pinnt beides deshalb zusammen.

   ── Kein Koexistenz-Zweig ──
   assets/sb-brevo.js laedt sofort, solange Consentik aktiv ist —
   sonst waere der Chat ueber Nacht weg. Hier ist das Gegenteil
   richtig: ohne lesbaren Datensatz bleibt der Platzhalter stehen,
   und der ist nie schlechter als der Ist-Zustand. Ein Klick ist
   immer moeglich.

   ── Reihenfolge ──
   Das Snippet steht im Seiteninhalt, sb-consent.js erst vor
   </body>. Dieses Skript laeuft also VOR sb-consent.js. Deshalb
   dasselbe Muster wie in assets/sb-brevo.js: erst den Listener
   registrieren, dann EINMAL synchron SBConsent.get() nachlesen —
   das deckt den Fall ab, dass sb-consent.js schon gelaufen ist
   und sein Event bereits weg war. Kein Poll.
   ============================================================ */

(function () {
  'use strict';

  if (window.SBConsentEmbed) return;

  var SELECTOR = '[data-sb-consent-embed]';

  /**
   * Freigabe per Einwilligung. Bewusst streng: fehlt der Satz, ist
   * p nicht exakt 1, fehlt der Zeitstempel oder liegt er vor dem
   * Stichtag, bleibt der Platzhalter stehen. Bei Unsicherheit ist
   * Nichtladen die sichere Richtung.
   *
   * ── Warum Date.parse und kein Zeichenkettenvergleich ──
   * Hier stand einmal `rec.t >= since` mit der Begruendung, rec.t sei
   * ein toISOString()-Wert und habe damit dasselbe Format wie since.
   * Das gilt nur fuers SCHREIBEN. Beim LESEN prueft parse() in
   * assets/sb-consent.js den Zeitstempel bloss mit
   * `typeof rec.t !== 'string' || !rec.t` — kein Formatcheck. Im
   * Cookie kann also jede Zeichenkette stehen, und der Vertrag mit
   * dem Hub laesst Zonenversatz ausdruecklich zu (ISO_SHAPE endet auf
   * `(?:Z|[+-]\d{2}:\d{2})`).
   *
   * Der Bruch ist nicht theoretisch: '2026-09-25T01:00:00+02:00' ist
   * real 2026-09-24T23:00:00Z und liegt damit VOR dem Stichtag
   * '2026-09-25T00:00:00Z' — lexikalisch steht es danach, weil der
   * Vergleich bei 'T0' auf '1' gegen '0' trifft. Die Karte laedt dann
   * automatisch fuer eine Einwilligung, die den Text nie gesehen hat.
   * Der umgekehrte Fall existiert ebenso und sperrt eine gueltige.
   *
   * Deshalb beide Seiten durch Date.parse. Dieselbe Pruefung fahrt
   * die Probefahrt-Extension (MAPS_CONSENT_TEXT_SINCE).
   *
   * Unlesbares sperrt ohne eigenen Guard: Date.parse liefert dann NaN,
   * und JEDER Vergleich mit NaN ist falsch. Hier standen kurz ein
   * Number.isFinite und eine Typpruefung auf `since` davor — beide hat
   * der Mutationslauf als wirkungslos entlarvt, weil Date.parse('') und
   * Date.parse(null) ebenfalls NaN ergeben. Ungetestete Guards bleiben
   * nicht stehen (Regel aus CLAUDE.md, Abschnitt Sentry). Die beiden
   * 'unlesbar'-Faelle im Harness halten das Verhalten trotzdem fest,
   * damit ein spaeteres `Date.parse(...) || 0` auffliegt.
   *
   * Die Typpruefung auf rec.t bleibt, und zwar nicht aus Symmetrie: ein
   * Array wie ['2099-01-01T00:00:00Z'] wird fuer Date.parse zur
   * Zeichenkette und kaeme sonst durch.
   *
   * ── Warum beide Werte die Zeitzone mitbringen muessen ──
   * Eine ISO-Zeit OHNE Zone liest Date.parse seit ES2015 als ORTSZEIT.
   * '2026-09-25T00:00:00' waere je nach Besucher um bis zu 14 Stunden
   * verschoben, und der Stichtag entschiede fuer jeden anders. Fehlt die
   * Zone, wird deshalb gesperrt statt geraten -- die sichere Richtung.
   * Legitime Werte verlieren dabei nichts: makeRecord() schreibt
   * toISOString() mit Z, und der Hub-Vertrag verlangt die Zone ohnehin
   * (ISO_SHAPE in src/lib/tracking/consent.ts endet auf
   * `(?:Z|[+-]\d{2}:\d{2})`). Versatz ist erlaubt, Fehlen nicht.
   */
  var ZONED = /(?:Z|[+-]\d{2}:\d{2})$/;

  function allowed(rec, since) {
    if (!rec || rec.p !== 1) return false;
    if (typeof rec.t !== 'string' || !ZONED.test(rec.t)) return false;
    if (!ZONED.test(since)) return false;
    return Date.parse(rec.t) >= Date.parse(since);
  }

  function load(root, focus) {
    if (!root || root.dataset.sbceLoaded) return;

    var src = root.getAttribute('data-src');
    if (!src) return;

    root.dataset.sbceLoaded = '1';

    var frame = document.createElement('iframe');
    frame.src = src;
    frame.title = root.getAttribute('data-title') || '';
    frame.loading = 'lazy';
    // Kein Referrer: der Embed braucht keinen Schluessel, also auch
    // keine Referrer-Pruefung auf Google-Seite.
    frame.setAttribute('referrerpolicy', 'no-referrer');
    frame.setAttribute('allowfullscreen', '');
    frame.className = 'sbce__frame';

    var placeholder = root.querySelector('[data-sbce-placeholder]');
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.removeChild(placeholder);
    }

    root.appendChild(frame);
    root.dataset.sbceState = 'loaded';

    // Der Klick hat den Knopf aus dem DOM entfernt. Ohne das hier
    // verloere eine Tastatur-Bedienung ihre Position und finge beim
    // naechsten Tabulator oben auf der Seite wieder an.
    if (focus) {
      try {
        frame.setAttribute('tabindex', '-1');
        frame.focus();
      } catch (e) {
        /* Fokus ist Komfort, kein Vertrag. */
      }
    }
  }

  function apply(root, rec) {
    if (allowed(rec, root.getAttribute('data-since'))) load(root, false);
  }

  function init(root) {
    if (!root || root.dataset.sbceInit) return;
    root.dataset.sbceInit = '1';

    var btn = root.querySelector('[data-sbce-load]');
    if (btn) {
      btn.addEventListener('click', function () {
        load(root, true);
      });
    }

    if (window.SBConsent && typeof window.SBConsent.get === 'function') {
      apply(root, window.SBConsent.get());
    }
  }

  function each(scope, fn) {
    var list = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) fn(list[i]);
  }

  function initAll(scope) {
    each(scope, init);
  }

  document.addEventListener('sb:consent', function (e) {
    each(document, function (root) {
      apply(root, e.detail);
    });
  });

  initAll();
  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });
  // Ohne diesen Listener sind Instanzen im Theme-Editor nach dem
  // ersten Setting-Wechsel tot: eine Datei in assets/ laeuft genau
  // einmal, ein Inline-Skript bei jedem Section-Reload neu.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.SBConsentEmbed = {
    initAll: initAll,
    _allowed: allowed
  };
})();
